import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { AcneBodyWashModalContent } from './modals/AcneBodyWashModalContent';
import { BarrierBalmModalContent } from './modals/BarrierBalmModalContent';
import { BodyCleanseModalContent } from './modals/BodyCleanseModalContent';
import { CleanserAndMoisturizerModalContent } from './modals/CleanserAndMoisturizerModalContent';
import { CleanserAndRichMoisturizerModalContent } from './modals/CleanserAndRichMoisturizerModalContent';
import { CloudCareDuoModalContent } from './modals/CloudCareDuoModalContent';
import { CustomFormulaModalContent } from './modals/CustomFormulaModalContent';
import { DarkSpotFormulaModalContent } from './modals/DarkSpotFormulaModalContent';
import { DayPrimeModalContent } from './modals/DayPrimeModalContent';
import { EmergencySpotPatchesModalContent } from './modals/EmergencySpotPatchesModalContent';
import { EyeFormulaModalContent } from './modals/EyeFormulaModalContent';
import { FutureFormulaModalContent } from './modals/FutureFormulaModalContent';
import { FutureProofModalContent } from './modals/FutureProofModalContent';
import { HairFormulaRxModalContent } from './modals/HairFormulaRxModalContent';
import { HydroPlusCleanserAndMoisturizerModalContent } from './modals/HydroPlusCleanserAndMoisturizerModalContent';
import { HydroTretModalContent } from './modals/HydroTretModalContent';
import { LipBalmModalContent } from './modals/LipBalmModalContent';
import { MicellarMakeupRemoverModalContent } from './modals/MicellarMakeupRemoverModalContent';
import { SilkScreenModalContent } from './modals/SilkScreenModalContent';

export type ModalContentProps = {
  modalCard: Card;
};

const componentNameMapping: Partial<
  Record<string, React.FC<ModalContentProps>>
> = {
  AcneBodyWashModalContent,
  BarrierBalmModalContent,
  BodyCleanseModalContent,
  CleanserAndMoisturizerModalContent,
  CleanserAndRichMoisturizerModalContent,
  CloudCareDuoModalContent,
  CustomFormulaModalContent,
  DarkSpotFormulaModalContent,
  DayPrimeModalContent,
  EmergencySpotPatchesModalContent,
  EyeFormulaModalContent,
  FutureFormulaModalContent,
  FutureProofModalContent,
  HairFormulaRxModalContent,
  HydroPlusCleanserAndMoisturizerModalContent,
  HydroTretModalContent,
  LipBalmModalContent,
  MicellarMakeupRemoverModalContent,
  SilkScreenModalContent,
};

export const ModalContentRouter = ({ modalCard }: { modalCard: Card }) => {
  const Component = componentNameMapping[modalCard.modal.componentName];

  if (!Component) {
    throw new Error(
      `ProductIngredientModalContent: No component found for ${modalCard.modal.componentName}`,
    );
  }

  return <Component modalCard={modalCard} />;
};
